import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser'
import { ImportedNewsRoutingModule } from './imported-news-routing.module';
import { MainListComponent } from './main-list/main-list.component';
import { GujaratListComponent } from './gujarat-list/gujarat-list.component';
import { BollywoodListComponent } from './bollywood-list/bollywood-list.component';
import { SportsListComponent } from './sports-list/sports-list.component';
import { InternationalListComponent } from './international-list/international-list.component';
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [MainListComponent, GujaratListComponent, BollywoodListComponent, SportsListComponent, InternationalListComponent, SafeHtmlPipe],
  imports: [
    CommonModule,
    ImportedNewsRoutingModule
  ]
})
export class ImportedNewsModule { }
